/**
 *
 * @param type String: Game type
 * @returns String
 * @description Gets a game type string from provider and returns a standardized/normalized game type string
 */
const getNormalizedGameType = (type?: string) => {
	if (!type) {
		return null;
	}

	const blackjack = [
		'blackjack', // evo-new, onair
		'Blackjack', // evo-old
		'BLACKJACK', // pragmatic
		'bjl', // playtech
		'ubjl', // playtech
		'sbjl' // playtech
	];
	const roulette = [
		'roulette', // evo-new, onair
		'Roulette', // evo-old
		'ROULETTE', // pragmatic
		'rol', // playtech
		'rofl', // playtech
		'rodzl', // playtech
		'wwtbamrol', // playtech
		'ccrol', // playtech
		'sbrol' // playtech
	];

	if (blackjack.includes(type)) return 'blackjack';
	if (roulette.includes(type)) return 'roulette';

	return null;
};

export default getNormalizedGameType;
